import { useEffect, useRef } from 'react';
import { WifiOff } from 'lucide-react';
import { toast } from 'sonner';
import { useOnline } from '@/hooks/useOnline';

/**
 * Persistent banner shown when the browser reports it's offline, plus a
 * one-shot "reconnected" toast when the link comes back so the cashier knows
 * it's safe to process payments again.
 */
export function OfflineBanner() {
  const online = useOnline();
  // Skip the toast on first mount — only fire on an offline → online recovery.
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!online) {
      wasOffline.current = true;
    } else if (wasOffline.current) {
      wasOffline.current = false;
      toast.success('Koneksi tersambung kembali. Transaksi dapat dilanjutkan.');
    }
  }, [online]);

  if (online) return null;

  return (
    <div className="flex items-center justify-center gap-2 bg-destructive px-4 py-1.5 text-sm font-semibold text-destructive-foreground">
      <WifiOff className="h-4 w-4" />
      Koneksi terputus — beberapa fitur mungkin tidak berfungsi.
    </div>
  );
}
